module.exports = __webpack_public_path__ + "img/mercurialeComparative.e1114705.png";